import { render, staticRenderFns } from "./lend_return_dialog.vue?vue&type=template&id=0827c5ad&scoped=true"
import script from "./lend_return_dialog.vue?vue&type=script&lang=js"
export * from "./lend_return_dialog.vue?vue&type=script&lang=js"
import style0 from "./lend_return_dialog.vue?vue&type=style&index=0&id=0827c5ad&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0827c5ad",
  null
  
)

export default component.exports